/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_BenchmarksInputs */

const en_common_header_benchmarks = /** @type {(inputs: Common_Header_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarks`)
};

const zh_common_header_benchmarks = /** @type {(inputs: Common_Header_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基准测试`)
};

/**
* | output |
* | --- |
* | "Benchmarks" |
*
* @param {Common_Header_BenchmarksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_benchmarks = /** @type {((inputs?: Common_Header_BenchmarksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_BenchmarksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_benchmarks(inputs)
	return zh_common_header_benchmarks(inputs)
});
export { common_header_benchmarks as "common.header.benchmarks" }